import React from 'react';
import appBranding from '@happylife-a/branding';
import webApp from '@happylife-a/web-app';
import webCore from '@happylife-a/web-core';
import { List, ListItem, ListIcon, Text, Flex } from '@chakra-ui/react';
import useGetGrantMenuItem from '~hooks/useGetGrantMenuItem';

export default function AccountMenu() {
  const { t } = webCore.contexts.useTranslation();
  const grantMenuItem = useGetGrantMenuItem();

  const location = webApp.router.useLocation();
  const { dispatch } = webApp.contexts.useModal();

  const onLogOutClick = () => {
    dispatch({ type: 'open', modal: webApp.constants.ENUM_MODAL_LOG_OUT });
  };

  const onOpenDeleteAccountModal = () => {
    dispatch({
      type: 'open',
      modal: webApp.constants.ENUM_MODAL_DELETE_ACCOUNT,
    });
  };

  const isMdOrBigger = webApp.theme.hooks.useIsBreakpointGreaterOrEqual('md');
  const isActiveMenu = (item) => {
    return location.pathname.split('/').pop() === item.split('/').pop();
  };

  const showPaymentMethods = webCore.helpers.shouldShowPaymentMethods();

  const MENUITEMS = [
    {
      name: 'My profile',
      link: '/account/profile',
      icon: webApp.theme.icons.UserProfile,
    },
    ...(showPaymentMethods
      ? [
          {
            name: 'Payment methods',
            link: '/account/payment-methods',
            icon: webApp.theme.icons.EmptyWallet,
          },
        ]
      : []),
    ...(appBranding.tools.features.isEnabled('BookingHistoryEnabled')
      ? [
          {
            name: 'Booking history',
            link: '/account/booking-history',
            icon: webApp.theme.icons.BookingHistory,
          },
        ]
      : [
          {
            name: 'Order history',
            link: '/order-history',
            icon: webApp.theme.icons.OrderHistoryIcon,
          },
        ]),

    {
      name: 'Security',
      link: '/account/security',
      icon: webApp.theme.icons.SecurityIcon,
    },
    ...(appBranding.tools.features.isEnabled('ShowProfileFaq')
      ? [
          {
            name: 'Customer service',
            link: '/account/customer-service',
            icon: webApp.theme.icons.UserProfile,
          },
        ]
      : []),

    {
      name: 'Privacy policy',
      link: '/privacy-policy',
      icon: webApp.theme.icons.Lock,
    },
  ];

  const menuItems = [...MENUITEMS, ...grantMenuItem];

  return (
    <List spacing={4}>
      {menuItems.map((item, idx) => (
        <ListItem
          key={`item-${item.name}-${idx}`}
          pos="relative"
          cursor="pointer"
          color={isActiveMenu(item.link) ? 'primary.500' : 'black.50'}
          _after={{
            content: "''",
            pos: 'absolute',
            left: -2,
            top: '-2px',
            width: `${isActiveMenu(item.link) ? '3px' : 0}`,
            height: '32px',
            borderRadius: '44px',
            bg: 'primary.500',
          }}
        >
          <webApp.components.LocalizedLink
            to={item.link}
            target={item.link === '/privacy-policy' && '_blank'}
          >
            {!isMdOrBigger ? (
              t(item.name)
            ) : (
              <Flex>
                <ListIcon
                  as={item.icon}
                  fill="none"
                  stroke={isActiveMenu(item.link) ? 'primary.500' : 'black.50'}
                  w={6}
                  h={6}
                />
                <Text variant="body-med">{t(item.name)}</Text>
              </Flex>
            )}
          </webApp.components.LocalizedLink>
        </ListItem>
      ))}
      <ListItem pos="relative" cursor="pointer" onClick={onLogOutClick}>
        <ListIcon
          as={webApp.theme.icons.LogOut}
          fill="none"
          stroke={webApp.theme.colors.black[50]}
          w={6}
          h={6}
        />
        {t('Log out')}
      </ListItem>
      {isMdOrBigger && (
        <ListItem
          pos="relative"
          cursor="pointer"
          color="red.300"
          onClick={onOpenDeleteAccountModal}
        >
          <ListIcon
            as={webApp.theme.icons.TrashIcon}
            fill="none"
            stroke={webApp.theme.colors.red[500]}
            w={6}
            h={6}
          />
          {t('Delete account')}
        </ListItem>
      )}
    </List>
  );
}
